import { useQuery } from '@tanstack/react-query';
import { getPrescriptionService } from '../../../domains/prescriptions';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

/**
 * 환자관리 탭 상세 조회 (`/prescription/patients/{userId}`).
 * - usePatientDetail은 adherence dosage detail 전용 (별도 hook)
 */
export const usePatientProfile = (userId: number | string | null | undefined) => {
  return useQuery({
    queryKey: ['patient-profile', userId],
    enabled: userId != null && userId !== '',
    queryFn: async () => {
      const res = await getPrescriptionService().getPatientDetail(userId);
      if (!isResultOk(res)) return null;
      return res?.data ?? null;
    },
  });
};
